(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-hide"]) return;
  try {
    
  class CollectionProductHide extends HTMLElement {
    static parseHideTags(search, limit = 20) {
      const rawValue = new URLSearchParams(search).get('hide');
      if (!rawValue) return [];

      const tags = [];
      const seen = new Set();
      for (const value of rawValue.split(',')) {
        const tag = value.trim().toLowerCase();
        if (!tag || seen.has(tag)) continue;

        seen.add(tag);
        tags.push(tag);
        if (tags.length === limit) break;
      }

      return tags;
    }

    static tagsFor(element) {
      if (!element) return [];
      const rawValue = element.dataset?.productTags;
      if (!rawValue) return [];

      return rawValue.split(',').map((tag) => tag.trim().toLowerCase()).filter(Boolean);
    }

    static matchesAny(hideTags, productTags) {
      const hidden = new Set(hideTags);
      return productTags.some((tag) => hidden.has(tag));
    }

    static productIdFor(element) {
      if (!element) return '';
      const wrapper = element.matches?.('[data-product-id]')
        ? element
        : element.querySelector?.('[data-product-id]');
      return wrapper?.dataset.productId || '';
    }

    static hideMatchingCards(grid, hideTags) {
      const removed = [];
      const hiddenIds = [];
      if (!grid) return { removed, hiddenIds };

      for (const card of [...grid.querySelectorAll(':scope > li')]) {
        if (!CollectionProductHide.matchesAny(hideTags, CollectionProductHide.tagsFor(card))) continue;

        const productId = CollectionProductHide.productIdFor(card);
        card.remove();
        removed.push(card);
        if (productId) hiddenIds.push(productId);
      }

      return { removed, hiddenIds };
    }

    static findGrid() {
      return document.getElementById('product-grid');
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.run();
    }

    run() {
      const maxTags = Number.parseInt(this.dataset.maxTags, 10) || 20;
      this.hideTags = CollectionProductHide.parseHideTags(window.location.search, maxTags);

      if (this.hideTags.length === 0) {
        this.finish('idle', 0);
        return;
      }

      this.apply();
      this.startObservers();
      this.finish(this.hiddenIds.length > 0 ? 'applied' : 'none', this.hiddenIds.length);
    }

    apply() {
      const grid = CollectionProductHide.findGrid();
      if (!grid) {
        this.finish('unavailable', 0);
        return;
      }
      if (grid === this.grid) return;
      this.grid = grid;

      const result = CollectionProductHide.hideMatchingCards(grid, this.hideTags);
      this.hiddenIds = result.hiddenIds;
      this.refreshInfiniteScroll();
    }

    startObservers() {
      if (!this.grid) return;

      this.gridObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1 || node.tagName !== 'LI') continue;
            if (!CollectionProductHide.matchesAny(this.hideTags, CollectionProductHide.tagsFor(node))) continue;

            const productId = CollectionProductHide.productIdFor(node);
            node.remove();
            if (productId) this.hiddenIds.push(productId);
            this.refreshInfiniteScroll();
          }
        }
      });
      this.gridObserver.observe(this.grid, { childList: true });

      // Facets replace the grid container's innerHTML; the container itself
      // survives, so watching it catches grid re-renders and re-applies hide.
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        this.containerObserver = new MutationObserver(() => {
          const nextGrid = CollectionProductHide.findGrid();
          if (!nextGrid || nextGrid === this.grid) return;
          this.gridObserver?.disconnect();
          this.gridObserver = null;
          this.apply();
          this.startObservers();
        });
        this.containerObserver.observe(container, { childList: true });
      }
    }

    refreshInfiniteScroll() {
      const infiniteScroll = window.ResponsivePLPInfiniteScroll;
      if (typeof infiniteScroll?.insertLoaderAndSentinel !== 'function') return;
      if (this.refreshQueued) return;
      this.refreshQueued = true;

      window.requestAnimationFrame(() => {
        this.refreshQueued = false;
        if (this.grid?.isConnected) infiniteScroll.insertLoaderAndSentinel();
      });
    }

    finish(status, hiddenCount) {
      this.dataset.status = status;
      this.dataset.hiddenCount = String(hiddenCount);
      this.dispatchEvent(
        new CustomEvent('collection-product-hide:complete', {
          bubbles: true,
          detail: { status, hiddenCount },
        })
      );
    }
  }

  if (!customElements.get('collection-product-hide')) {
    customElements.define('collection-product-hide', CollectionProductHide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-priority-v2"]) return;
  try {
    
  class CollectionProductPriorityV2 extends HTMLElement {
    static parseProductIds(search, limit = 10) {
      const params = new URLSearchParams(search);
      const hasProd = params.has('prod');
      const rawValue = params.get('prodID') || (hasProd ? params.get('prod') : null);
      if (!rawValue) return [];

      const productIds = [];
      const seen = new Set();

      for (const value of rawValue.split(',')) {
        const item = value.trim();
        if (!item) continue;
        const id = item.includes(':') ? item.split(':')[0].trim() : item;
        if (!id || seen.has(id)) continue;

        if (!hasProd && !item.includes(':')) {
          if (!/^\d+$/.test(id)) continue;
        } else {
          if (!/^[a-zA-Z0-9_-]+$/.test(id)) continue;
        }

        seen.add(id);
        productIds.push(id);
        if (productIds.length === limit) break;
      }

      return productIds;
    }

    static parseRequest(search, limit = 10) {
      const params = new URLSearchParams(search);
      const hasProd = params.has('prod');
      const rawIds = (params.get('prodID') || (hasProd ? params.get('prod') : '') || '').split(',');
      const rawPositions = (params.get('prodIDpos') || (hasProd ? params.get('prodpos') : '') || '').split(',');

      const pairs = [];
      const seen = new Set();

      rawIds.forEach((rawItem, index) => {
        const item = rawItem.trim();
        if (!item) return;
        let id = item;
        let handle = null;

        if (item.includes(':')) {
          const parts = item.split(':');
          id = parts[0].trim();
          handle = parts[1].trim();
        } else if (hasProd && !/^\d+$/.test(item)) {
          handle = item;
        } else if (!/^\d+$/.test(item)) {
          return;
        }

        if (!/^[a-zA-Z0-9_-]+$/.test(id) || seen.has(id) || pairs.length >= limit) return;

        seen.add(id);
        const rawPosition = (rawPositions[index] || '').trim();
        const position = /^\d+$/.test(rawPosition) ? Number.parseInt(rawPosition, 10) : null;
        pairs.push({
          id,
          handle,
          position: Number.isInteger(position) && position >= 1 ? position : null,
        });
      });

      return pairs;
    }

    static productIdFor(element) {
      if (!element) return '';
      const wrapper = element.matches?.('[data-product-id]') ? element : element.querySelector?.('[data-product-id]');
      if (wrapper?.dataset?.productId) return wrapper.dataset.productId;
      return element.dataset?.productId || '';
    }

    static handleFor(element) {
      if (!element) return '';
      const direct = element.dataset?.productHandle || element.querySelector?.('[data-product-handle]')?.dataset?.productHandle;
      if (direct) return direct;
      const link = element.querySelector?.('a[href*="/products/"]') || (element.matches?.('a[href*="/products/"]') ? element : null);
      if (link) {
        const href = link.getAttribute('href') || '';
        const match = href.match(/\/products\/([^/?#]+)/);
        if (match) return match[1];
      }
      return '';
    }
    static pageForPosition(position, productsPerPage) {
      return Math.floor(position / productsPerPage) + 1;
    }

    static resolveProductsPerPage(grid) {
      const fromGrid = Number.parseInt(grid?.dataset?.productsPerPage, 10);
      if (Number.isInteger(fromGrid) && fromGrid > 0) return fromGrid;

      const backfill = typeof document?.querySelector === 'function'
        ? document.querySelector('collection-backfill')
        : null;
      const fromBackfill = Number.parseInt(backfill?.dataset?.productsPerPage, 10);
      if (Number.isInteger(fromBackfill) && fromBackfill > 0) return fromBackfill;

      return 48;
    }

    static availableRequestedIds(requestedIds, availableIds) {
      const available = new Set(availableIds);
      return requestedIds.filter((productId) => available.has(productId));
    }

    static planPlacements(pairs, appliedIds) {
      const applied = new Set(appliedIds);
      const planned = pairs
        .filter((pair) => applied.has(pair.id) || (pair.handle && applied.has(pair.handle)))
        .map((pair) => ({ id: pair.id, position: pair.position }));

      const used = new Set();
      for (const pair of planned) {
        if (pair.position === null) continue;
        if (used.has(pair.position)) {
          pair.position = null;
        } else {
          used.add(pair.position);
        }
      }

      let anchor = null;
      for (const pair of planned) if (pair.position !== null) anchor = pair;

      if (!anchor) {
        planned.forEach((pair, index) => {
          pair.position = index + 1;
          used.add(pair.position);
        });
      } else {
        let next = anchor.position + 1;
        for (const pair of planned) {
          if (pair.position !== null) continue;
          while (used.has(next)) next += 1;
          pair.position = next;
          used.add(next);
          next += 1;
        }
      }

      return new Map(planned.map((pair) => [pair.id, pair.position]));
    }

    static composeOrder(totalCount, placements) {
      const slots = new Array(totalCount).fill(null);
      const overflow = [];
      const ordered = [...placements.entries()].sort((a, b) => a[1] - b[1]);

      for (const [productId, position] of ordered) {
        if (position >= 1 && position <= totalCount && !slots[position - 1]) {
          slots[position - 1] = productId;
        } else {
          overflow.push(productId);
        }
      }

      if (overflow.length > 0) {
        const freeTail = [];
        for (let index = totalCount; index >= 1 && freeTail.length < overflow.length; index -= 1) {
          if (slots[index - 1] === null) freeTail.push(index);
        }
        freeTail.reverse();
        overflow.forEach((productId, index) => {
          if (freeTail[index] !== undefined) slots[freeTail[index] - 1] = productId;
        });
      }

      return slots;
    }

    static mergeFixedPositions(productCount, fixedIndices) {
      const finalCount = productCount + fixedIndices.length;
      const sequence = [];
      let productIndex = 0;
      let fixedIndex = 0;

      for (let position = 0; position < finalCount; position += 1) {
        if (fixedIndex < fixedIndices.length && fixedIndices[fixedIndex] <= position) {
          sequence.push('fixed');
          fixedIndex += 1;
        } else {
          sequence.push(productIndex);
          productIndex += 1;
        }
      }

      return sequence;
    }

    static buildSectionUrl(href, sectionId, page) {
      const url = new URL(href);
      url.hash = '';
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', String(page));
      return url;
    }

    static buildCollectionUrl(href, collectionPath) {
      const url = new URL(href);
      url.pathname = collectionPath;
      url.hash = '';
      url.searchParams.delete('page');
      return url;
    }

    static getCachedCard(key) {
      try {
        const html = sessionStorage.getItem('pf_c_' + key);
        if (!html) return null;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('li') || doc.body.firstElementChild;
      } catch (e) {
        return null;
      }
    }

    static setCachedCard(key, card) {
      try {
        if (card && key) {
          sessionStorage.setItem('pf_c_' + key, card.outerHTML || '');
        }
      } catch (e) {}
    }

    static getCachedHandle(id) {
      try {
        return sessionStorage.getItem('pf_h_' + id) || null;
      } catch (e) {
        return null;
      }
    }

    static setCachedHandle(id, handle) {
      try {
        if (id && handle) {
          sessionStorage.setItem('pf_h_' + id, handle);
        }
      } catch (e) {}
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.handleMap = new Map();

      const start = () => {
        if (this.dataset.status === 'applied') return;
        this.run().catch(() => this.finish('error', []));
      };

      if (document.getElementById('product-grid')?.dataset?.id) {
        start();
      } else {
        const poll = setInterval(() => {
          if (document.getElementById('product-grid')?.dataset?.id) {
            clearInterval(poll);
            start();
          }
        }, 10);

        if (typeof document !== 'undefined' && document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            clearInterval(poll);
            start();
          }, { once: true });
        }
      }
    }

    async run() {
      const maxProducts = Number.parseInt(this.dataset.maxProducts, 10) || 10;
      this.request = CollectionProductPriorityV2.parseRequest(window.location.search, maxProducts);
      this.requestedIds = this.request.map((pair) => pair.id);

      if (this.requestedIds.length === 0) {
        this.finish('idle', []);
        return;
      }

      const currentPage = Number.parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;
      if (currentPage !== 1) {
        this.finish('skipped', []);
        return;
      }

      this.grid = document.getElementById('product-grid');
      if (!this.grid?.dataset.id) {
        this.finish('unavailable', []);
        return;
      }

      this.gridSectionId = this.grid.dataset.id;
      this.totalProducts = Number.parseInt(this.dataset.totalProducts, 10);
      this.productsPerPage = CollectionProductPriorityV2.resolveProductsPerPage(this.grid);
      this.dataset.status = 'loading';

      const currentCards = this.collectCurrentCards();
      const fetchedCards = new Map();

      // Check client-side cache first for missing cards
      for (const pair of this.request) {
        if (!currentCards.has(pair.id)) {
          const cached = CollectionProductPriorityV2.getCachedCard(pair.id) ||
            (pair.handle ? CollectionProductPriorityV2.getCachedCard(pair.handle) : null);
          if (cached) {
            this.retargetCollectionContext(cached);
            fetchedCards.set(pair.id, cached);
          }
        }
      }

      let missingIds = this.requestedIds.filter(
        (productId) => !currentCards.has(productId) && !fetchedCards.has(productId)
      );

      if (missingIds.length > 0) {
        // Fast-path: if any missing item has an explicit or cached handle, fetch its card directly
        const directPromises = [];
        for (const productId of missingIds) {
          const pair = this.request.find((p) => p.id === productId);
          const handle = pair?.handle || CollectionProductPriorityV2.getCachedHandle(productId);
          if (handle) {
            directPromises.push(
              this.fetchDirectCard(handle, productId).then((card) => {
                if (card) fetchedCards.set(productId, card);
              })
            );
          }
        }

        if (directPromises.length > 0) {
          await Promise.all(directPromises);
          missingIds = missingIds.filter((productId) => !fetchedCards.has(productId));
        }
      }

      if (missingIds.length > 0) {
        const positions = await this.loadProductPositions(missingIds);
        const latestCards = this.collectCurrentCards();
        for (const [productId, card] of latestCards) currentCards.set(productId, card);
        missingIds = missingIds.filter((productId) => !currentCards.has(productId) && !fetchedCards.has(productId));

        // For in-collection items, fetch direct card if handle known, or fetch grid page
        const pages = new Set();
        const inCollectionDirect = [];
        for (const productId of missingIds) {
          const handle = this.handleMap.get(productId);
          if (handle) {
            inCollectionDirect.push(
              this.fetchDirectCard(handle, productId).then((card) => {
                if (card) fetchedCards.set(productId, card);
              })
            );
          } else {
            const position = positions.get(productId);
            if (Number.isInteger(position)) {
              pages.add(CollectionProductPriorityV2.pageForPosition(position, this.productsPerPage));
            }
          }
        }

        if (inCollectionDirect.length > 0) {
          await Promise.all(inCollectionDirect);
          missingIds = missingIds.filter((productId) => !fetchedCards.has(productId));
        }

        if (pages.size > 0) {
          const remoteCards = await this.loadCardsFromPages([...pages], new Set(missingIds));
          for (const [productId, card] of remoteCards) fetchedCards.set(productId, card);
          missingIds = missingIds.filter((productId) => !fetchedCards.has(productId));
        }

        // Out of collection fallback
        const outOfCollectionIds = missingIds.filter((productId) => !positions.has(productId));
        if (outOfCollectionIds.length > 0) {
          const allBase = CollectionProductPriorityV2.buildCollectionUrl(window.location.href, '/collections/all');
          const foreignCards = await this.loadForeignCards(outOfCollectionIds, allBase.href);
          for (const [productId, card] of foreignCards) fetchedCards.set(productId, card);
        }
      }

      const cards = new Map(currentCards);
      for (const [productId, card] of fetchedCards) {
        if (!cards.has(productId)) cards.set(productId, card);
      }

      const appliedIds = this.promoteCards(cards);
      this.finish(appliedIds.length === this.requestedIds.length ? 'applied' : 'partial', appliedIds);
    }

    collectCurrentCards() {
      const requested = new Set(this.requestedIds);
      const cards = new Map();

      for (const card of this.grid.querySelectorAll(':scope > li')) {
        const productId = CollectionProductPriorityV2.productIdFor(card);
        const handle = CollectionProductPriorityV2.handleFor(card);

        if (productId && handle) {
          if (!this.handleMap) this.handleMap = new Map();
          this.handleMap.set(productId, handle);
          CollectionProductPriorityV2.setCachedHandle(productId, handle);
        }

        if (productId && requested.has(productId) && !cards.has(productId)) {
          cards.set(productId, card);
        } else if (handle && requested.has(handle) && !cards.has(handle)) {
          cards.set(handle, card);
        }
      }

      return cards;
    }

    async fetchDirectCard(handle, productId) {
      if (!handle) return null;
      const prefetchMap = typeof window !== 'undefined' ? window.__printfreshPriorityPrefetch?.directCardMap : null;
      let textPromise = prefetchMap?.get(handle);
      if (!textPromise) {
        const url = '/products/' + encodeURIComponent(handle) + '?section_id=' + (this.dataset.cardSectionId || 'collection-product-priority-card');
        textPromise = fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          priority: 'high',
        }).then((res) => (res.ok ? res.text() : null)).catch(() => null);
      }

      const text = await textPromise;
      if (!text) return null;

      const doc = new DOMParser().parseFromString(text, 'text/html');
      const card = doc.querySelector('li') || doc.querySelector('.product-card-wrapper')?.closest('li') || doc.body.firstElementChild;
      if (!card) return null;

      this.retargetCollectionContext(card);
      CollectionProductPriorityV2.setCachedCard(productId || handle, card);
      if (productId && handle) CollectionProductPriorityV2.setCachedHandle(productId, handle);
      return card;
    }

    prefetchedIndexPageOne() {
      const prefetch = window.__printfreshPriorityPrefetch;
      if (
        !prefetch ||
        !Array.isArray(prefetch.productIds) ||
        prefetch.productIds.length !== this.requestedIds.length ||
        !this.requestedIds.every((productId, index) => prefetch.productIds[index] === productId) ||
        typeof prefetch.indexPageOne?.then !== 'function'
      ) {
        return null;
      }

      return prefetch.indexPageOne.then((text) => {
        if (!text) return null;
        return new DOMParser().parseFromString(text, 'text/html');
      });
    }

    async loadProductPositions(productIds, baseHref = window.location.href) {
      const remaining = new Set(productIds);
      const positions = new Map();

      const consume = (documentFragment) => {
        const payloadElement = documentFragment?.querySelector('[data-collection-product-priority-index]');
        if (!payloadElement) return 0;

        let payload;
        try {
          payload = JSON.parse(payloadElement.textContent);
        } catch {
          return 0;
        }

        for (const product of payload.products || []) {
          const productId = String(product.id);
          const handle = product.handle || '';
          if (handle) {
            if (!this.handleMap) this.handleMap = new Map();
            this.handleMap.set(productId, handle);
            CollectionProductPriorityV2.setCachedHandle(productId, handle);
          }

          if (!remaining.has(productId) && (!handle || !remaining.has(handle))) continue;

          const position = Number.parseInt(product.position, 10);
          if (Number.isInteger(position)) {
            positions.set(productId, position);
            if (handle) positions.set(handle, position);
          }
          remaining.delete(productId);
          if (handle) remaining.delete(handle);
        }

        return Number.parseInt(payload.pages, 10) || 1;
      };

      const indexPageOneUrl = CollectionProductPriorityV2.buildSectionUrl(
        baseHref,
        this.dataset.indexSectionId,
        1
      );
      const prefetched = baseHref === window.location.href ? this.prefetchedIndexPageOne() : null;
      let firstDocument = prefetched ? await prefetched : null;
      if (!firstDocument) firstDocument = await this.fetchSectionDocument(indexPageOneUrl);
      const pages = consume(firstDocument);
      if (pages === 0) return positions;

      if (pages > 1 && remaining.size > 0) {
        const restPages = [];
        for (let page = 2; page <= pages && page <= 100; page += 1) restPages.push(page);

        const chunkSize = 6;
        for (let start = 0; start < restPages.length && remaining.size > 0; start += chunkSize) {
          const chunk = restPages.slice(start, start + chunkSize);
          const documents = await Promise.all(
            chunk.map((page) =>
              this.fetchSectionDocument(
                CollectionProductPriorityV2.buildSectionUrl(baseHref, this.dataset.indexSectionId, page)
              )
            )
          );

          for (const documentFragment of documents) {
            consume(documentFragment);
            if (remaining.size === 0) break;
          }
        }
      }

      return positions;
    }

    async loadCardsFromPages(pages, requestedIds, baseHref = window.location.href) {
      const cards = new Map();

      await Promise.all(
        pages.map(async (page) => {
          const url = CollectionProductPriorityV2.buildSectionUrl(baseHref, this.gridSectionId, page);
          const documentFragment = await this.fetchSectionDocument(url);
          if (!documentFragment) return;

          for (const card of documentFragment.querySelectorAll('#product-grid > li')) {
            const productId = CollectionProductPriorityV2.productIdFor(card);
            if (requestedIds.has(productId) && !cards.has(productId)) {
              cards.set(productId, card);
              CollectionProductPriorityV2.setCachedCard(productId, card);
            }
          }
        })
      );

      return cards;
    }

    async fetchSectionDocument(url) {
      try {
        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          priority: 'high',
        });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      } catch {
        return null;
      }
    }

    promoteCards(cards) {
      const appliedIds = CollectionProductPriorityV2.availableRequestedIds(this.requestedIds, cards.keys());
      if (appliedIds.length === 0) return [];

      this.placements = CollectionProductPriorityV2.planPlacements(this.request, appliedIds);
      this.pinnedCards = new Map();

      for (const key of appliedIds) {
        const card = cards.get(key);
        if (!card) continue;
        if (!card.isConnected) card.dataset.productPriorityInjected = 'true';
        card.dataset.productPriorityId = key;
        this.pinnedCards.set(key, card);

        const id = CollectionProductPriorityV2.productIdFor(card);
        const handle = CollectionProductPriorityV2.handleFor(card);
        if (id) this.pinnedCards.set(id, card);
        if (handle) this.pinnedCards.set(handle, card);
      }

      const allChildren = [...this.grid.children];
      const fixedChildren = [];
      const productLis = [];
      allChildren.forEach((child, index) => {
        if (child.tagName === 'LI') {
          productLis.push(child);
        } else {
          fixedChildren.push({ node: child, index });
        }
      });

      const naturalCards = [];
      for (const child of productLis) {
        const productId = CollectionProductPriorityV2.productIdFor(child);
        const handle = CollectionProductPriorityV2.handleFor(child);
        if (
          (productId && this.pinnedCards.has(productId)) ||
          (handle && this.pinnedCards.has(handle))
        ) {
          continue;
        }
        naturalCards.push(child);
      }

      const totalCount = naturalCards.length + appliedIds.length;
      const slots = CollectionProductPriorityV2.composeOrder(totalCount, this.placements);

      let naturalIndex = 0;
      const productSequence = slots.map((pinnedKey, slotIndex) => {
        if (pinnedKey !== null) {
          const card = this.pinnedCards.get(pinnedKey);
          if (card) card.dataset.productPriorityRank = String(slotIndex + 1);
          return card;
        }
        const card = naturalCards[naturalIndex];
        naturalIndex += 1;
        return card;
      }).filter(Boolean);

      const mergeMap = CollectionProductPriorityV2.mergeFixedPositions(
        productSequence.length,
        fixedChildren.map((fixed) => fixed.index)
      );
      const fixedNodes = fixedChildren.map((fixed) => fixed.node);
      let fixedCursor = 0;
      for (const entry of mergeMap) {
        if (entry === 'fixed') {
          fixedCursor += 1;
          continue;
        }
        this.grid.insertBefore(productSequence[entry], fixedNodes[fixedCursor] || null);
      }

      this.startObservers();
      this.prioritizeFirstImage();
      this.initializeCards();
      this.synchronizeInfiniteScroll();
      this.updateMobileCounters();
      return appliedIds;
    }

    startObservers() {
      this.duplicateObserver = new MutationObserver((mutations) => {
        let removedDuplicate = false;

        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1 || node.parentElement !== this.grid || node.tagName !== 'LI') continue;

            const productId = CollectionProductPriorityV2.productIdFor(node);
            const handle = CollectionProductPriorityV2.handleFor(node);
            const pinnedCard = (productId && this.pinnedCards.get(productId)) ||
                               (handle && this.pinnedCards.get(handle));
            if (pinnedCard && node !== pinnedCard) {
              node.remove();
              removedDuplicate = true;
            }
          }
        }

        if (removedDuplicate) this.updateMobileCounters();
      });
      this.duplicateObserver.observe(this.grid, { childList: true });
      const gridParent = this.grid.parentElement;
      if (gridParent) {
        this.counterObserver = new MutationObserver(() => this.updateMobileCounters());
        this.counterObserver.observe(gridParent, { childList: true });
      }

      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer) {
        this.containerObserver = new MutationObserver(() => {
          if (!this.grid.isConnected) this.stopObservers();
        });
        this.containerObserver.observe(gridContainer, { childList: true });
      }
    }

    stopObservers() {
      this.duplicateObserver?.disconnect();
      this.counterObserver?.disconnect();
      this.containerObserver?.disconnect();
    }

    prioritizeFirstImage() {
      try {
        const firstPinned = [...this.pinnedCards.keys()].sort(
          (a, b) => (this.placements.get(a) || 0) - (this.placements.get(b) || 0)
        )[0];
        const firstImage = this.pinnedCards.get(firstPinned)?.querySelector('img');
        if (!firstImage) return;

        firstImage.loading = 'eager';
        firstImage.fetchPriority = 'high';
        firstImage.setAttribute('fetchpriority', 'high');
      } catch (e) {}
    }

    initializeCards() {
      for (const card of this.pinnedCards.values()) {
        try {
          if (card.dataset?.productPriorityInjected === 'true') this.bindCollectionTracking(card);
          window.ResponsivePLPInfiniteScroll?.markProductAsLoaded?.(card);
        } catch (e) {}
      }

      try {
        if (typeof window.initProductImageSlider === 'function') window.initProductImageSlider();
        window.ResponsivePLPInfiniteScroll?.initProductJS?.();
      } catch (e) {}

      try {
        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets(false);
        }
      } catch (e) {}
    }

    synchronizeInfiniteScroll() {
      try {
        for (const card of this.pinnedCards.values()) card.style.removeProperty('display');

        const infiniteScroll = window.ResponsivePLPInfiniteScroll;
        if (typeof infiniteScroll?.insertLoaderAndSentinel !== 'function') return;

        window.requestAnimationFrame(() => {
          if (!this.grid?.isConnected) return;
          for (const card of this.pinnedCards.values()) card.style.removeProperty('display');
          try {
            infiniteScroll.insertLoaderAndSentinel();
          } catch (e) {}
        });
      } catch (e) {}
    }

    async loadForeignCards(productIds, allBaseHref) {
      const cards = new Map();
      const directFetches = [];

      for (const productId of productIds) {
        const handle = (this.handleMap && this.handleMap.get(productId)) || CollectionProductPriorityV2.getCachedHandle(productId);
        if (handle) {
          directFetches.push(
            this.fetchDirectCard(handle, productId).then((card) => {
              if (card) cards.set(productId, card);
            })
          );
        }
      }

      if (directFetches.length > 0) {
        await Promise.all(directFetches);
      }

      const stillMissing = productIds.filter((id) => !cards.has(id));
      if (stillMissing.length === 0) return cards;

      const positions = await this.loadProductPositions(stillMissing, allBaseHref);

      // Now check if handles were discovered during /collections/all index scan
      const secondDirect = [];
      for (const productId of stillMissing) {
        const handle = this.handleMap && this.handleMap.get(productId);
        if (handle) {
          secondDirect.push(
            this.fetchDirectCard(handle, productId).then((card) => {
              if (card) cards.set(productId, card);
            })
          );
        }
      }

      if (secondDirect.length > 0) {
        await Promise.all(secondDirect);
      }

      const finalMissing = stillMissing.filter((id) => !cards.has(id));
      if (finalMissing.length > 0) {
        const pages = new Set();
        for (const productId of finalMissing) {
          const position = positions.get(productId);
          if (Number.isInteger(position)) {
            pages.add(CollectionProductPriorityV2.pageForPosition(position, this.productsPerPage));
          }
        }
        const remoteCards = await this.loadCardsFromPages([...pages], new Set(finalMissing), allBaseHref);
        for (const [productId, card] of remoteCards) {
          this.retargetCollectionContext(card);
          cards.set(productId, card);
        }
      }

      return cards;
    }

    retargetCollectionContext(card) {
      const source = this.grid?.querySelector('.product-card-wrapper[data-product-id]');
      const target = card?.querySelector?.('.product-card-wrapper[data-product-id]') || card?.querySelector?.('.product-card-wrapper') || card;
      if (target) {
        if (source?.dataset?.collection && target.dataset) target.dataset.collection = source.dataset.collection;
        if (source?.dataset?.collectionTitle && target.dataset) target.dataset.collectionTitle = source.dataset.collectionTitle;
      }

      const yotpo = card?.querySelector?.('.yotpo-widget-instance') || (card?.matches?.('.yotpo-widget-instance') ? card : null);
      if (yotpo) {
        yotpo.setAttribute('data-yotpo-section-id', 'collection');
      }
    }

    bindCollectionTracking(card) {
      const product = card.querySelector?.('.product-card-wrapper') || (card.matches?.('.product-card-wrapper') ? card : null);
      if (!product || product.dataset.priorityTrackingBound === 'true') return;
      product.dataset.priorityTrackingBound = 'true';

      product.addEventListener('click', (event) => {
        const link = event.target instanceof Element ? event.target.closest('[href]') : null;
        if (!link || !product.contains(link)) return;
        const productId = product.dataset.productId || card.dataset.productId;
        const collectionData = {
          title: product.dataset.collectionTitle || 'Collection',
          url: product.dataset.collection || window.location.pathname,
        };

        let productsCollectionData = [];
        try {
          productsCollectionData = JSON.parse(localStorage.getItem('productsCollection')) || [];
        } catch {
          productsCollectionData = [];
        }

        const existingProduct = productsCollectionData.find((item) => String(item.id) === productId);
        if (existingProduct) {
          existingProduct.collection = collectionData;
        } else {
          productsCollectionData.push({ id: productId, collection: collectionData });
        }

        try {
          localStorage.setItem('productsCollection', JSON.stringify(productsCollectionData));
        } catch {
          // Tracking is best-effort; native link navigation must always remain available.
        }
      });
    }

    updateMobileCounters() {
      const totalElement = document.getElementById('total-number');
      const viewedElement = document.getElementById('current-last-viewed');

      if (Number.isInteger(this.totalProducts)) {
        if (totalElement) totalElement.textContent = String(this.totalProducts);
        if (window.ResponsivePLPInfiniteScroll && 'totalProductCount' in window.ResponsivePLPInfiniteScroll) {
          window.ResponsivePLPInfiniteScroll.totalProductCount = this.totalProducts;
        }
      }

      if (viewedElement) {
        const visibleProductIds = new Set(
          [...this.grid.querySelectorAll(':scope > li')]
            .map((card) => CollectionProductPriorityV2.productIdFor(card))
            .filter(Boolean)
        );
        viewedElement.textContent = String(visibleProductIds.size);
      }
    }

    finish(status, appliedIds) {
      this.dataset.status = status;
      this.dataset.requestedIds = (this.requestedIds || []).join(',');
      this.dataset.appliedIds = appliedIds.join(',');
      this.dispatchEvent(
        new CustomEvent('collection-product-priority:complete', {
          bubbles: true,
          detail: {
            status,
            requestedIds: this.requestedIds || [],
            appliedIds,
          },
        })
      );
    }
  }

  if (!customElements.get('collection-product-priority-v2')) {
    customElements.define('collection-product-priority-v2', CollectionProductPriorityV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-priority"]) return;
  try {
    
  class CollectionProductPriority extends HTMLElement {
    static parseProductIds(search, limit = 10) {
      const rawValue = new URLSearchParams(search).get('prodID');
      if (!rawValue) return [];

      const productIds = [];
      const seen = new Set();

      for (const value of rawValue.split(',')) {
        const productId = value.trim();
        if (!/^\d+$/.test(productId) || seen.has(productId)) continue;

        seen.add(productId);
        productIds.push(productId);
        if (productIds.length === limit) break;
      }

      return productIds;
    }

    static productIdFor(element) {
      if (!element) return '';
      const wrapper = element.matches?.('[data-product-id]') ? element : element.querySelector?.('[data-product-id]');
      return wrapper?.dataset.productId || '';
    }

    static pageForPosition(position, productsPerPage) {
      return Math.floor(position / productsPerPage) + 1;
    }

    static availableRequestedIds(requestedIds, availableIds) {
      const available = new Set(availableIds);
      return requestedIds.filter((productId) => available.has(productId));
    }

    static buildSectionUrl(href, sectionId, page) {
      const url = new URL(href);
      url.hash = '';
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', String(page));
      return url;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.run().catch(() => this.finish('error', []));
    }

    async run() {
      const maxProducts = Number.parseInt(this.dataset.maxProducts, 10) || 10;
      this.requestedIds = CollectionProductPriority.parseProductIds(window.location.search, maxProducts);

      if (this.requestedIds.length === 0) {
        this.finish('idle', []);
        return;
      }

      const currentPage = Number.parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;
      if (currentPage !== 1) {
        this.finish('skipped', []);
        return;
      }

      this.grid = document.getElementById('product-grid');
      if (!this.grid?.dataset.id) {
        this.finish('unavailable', []);
        return;
      }

      this.gridSectionId = this.grid.dataset.id;
      this.totalProducts = Number.parseInt(this.dataset.totalProducts, 10);
      this.productsPerPage = Number.parseInt(
        document.querySelector('collection-backfill')?.dataset.productsPerPage,
        10
      ) || 48;
      this.dataset.status = 'loading';

      const currentCards = this.collectCurrentCards();
      let missingIds = this.requestedIds.filter((productId) => !currentCards.has(productId));
      const fetchedCards = new Map();

      if (missingIds.length > 0) {
        const positions = await this.loadProductPositions(missingIds);
        const latestCards = this.collectCurrentCards();
        for (const [productId, card] of latestCards) currentCards.set(productId, card);
        missingIds = missingIds.filter((productId) => !currentCards.has(productId));

        const pages = new Set();
        for (const productId of missingIds) {
          const position = positions.get(productId);
          if (Number.isInteger(position)) {
            pages.add(CollectionProductPriority.pageForPosition(position, this.productsPerPage));
          }
        }

        const remoteCards = await this.loadCardsFromPages([...pages], new Set(missingIds));
        for (const [productId, card] of remoteCards) fetchedCards.set(productId, card);
      }

      const cards = new Map(currentCards);
      for (const [productId, card] of fetchedCards) {
        if (!cards.has(productId)) cards.set(productId, card);
      }

      const appliedIds = this.promoteCards(cards);
      this.finish(appliedIds.length === this.requestedIds.length ? 'applied' : 'partial', appliedIds);
    }

    collectCurrentCards() {
      const requested = new Set(this.requestedIds);
      const cards = new Map();

      for (const card of this.grid.querySelectorAll(':scope > li')) {
        const productId = CollectionProductPriority.productIdFor(card);
        if (requested.has(productId) && !cards.has(productId)) cards.set(productId, card);
      }

      return cards;
    }

    async loadProductPositions(productIds) {
      const remaining = new Set(productIds);
      const positions = new Map();
      let page = 1;
      let pages = 1;

      while (remaining.size > 0 && page <= pages && page <= 100) {
        const url = CollectionProductPriority.buildSectionUrl(
          window.location.href,
          this.dataset.indexSectionId,
          page
        );
        const documentFragment = await this.fetchSectionDocument(url);
        if (!documentFragment) break;

        const payloadElement = documentFragment.querySelector('[data-collection-product-priority-index]');
        if (!payloadElement) break;

        let payload;
        try {
          payload = JSON.parse(payloadElement.textContent);
        } catch {
          break;
        }

        pages = Number.parseInt(payload.pages, 10) || 1;
        for (const product of payload.products || []) {
          const productId = String(product.id);
          if (!remaining.has(productId)) continue;

          const position = Number.parseInt(product.position, 10);
          if (Number.isInteger(position)) positions.set(productId, position);
          remaining.delete(productId);
        }

        page += 1;
      }

      return positions;
    }

    async loadCardsFromPages(pages, requestedIds) {
      const cards = new Map();

      await Promise.all(
        pages.map(async (page) => {
          const url = CollectionProductPriority.buildSectionUrl(window.location.href, this.gridSectionId, page);
          const documentFragment = await this.fetchSectionDocument(url);
          if (!documentFragment) return;

          for (const card of documentFragment.querySelectorAll('#product-grid > li')) {
            const productId = CollectionProductPriority.productIdFor(card);
            if (requestedIds.has(productId) && !cards.has(productId)) cards.set(productId, card);
          }
        })
      );

      return cards;
    }

    async fetchSectionDocument(url) {
      try {
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      } catch {
        return null;
      }
    }

    promoteCards(cards) {
      const appliedIds = CollectionProductPriority.availableRequestedIds(this.requestedIds, cards.keys());
      if (appliedIds.length === 0) return [];

      this.pinnedCards = new Map();
      const fragment = document.createDocumentFragment();

      appliedIds.forEach((productId, index) => {
        const card = cards.get(productId);
        if (!card.isConnected) card.dataset.productPriorityInjected = 'true';
        card.dataset.productPriorityId = productId;
        card.dataset.productPriorityRank = String(index + 1);
        this.pinnedCards.set(productId, card);
        fragment.appendChild(card);
      });

      this.startObservers();
      this.grid.prepend(fragment);
      this.removeDuplicates();
      this.prioritizeFirstImage();
      this.initializeCards();
      this.synchronizeInfiniteScroll();
      this.updateMobileCounters();
      return appliedIds;
    }

    startObservers() {
      this.duplicateObserver = new MutationObserver((mutations) => {
        let removedDuplicate = false;

        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1 || node.parentElement !== this.grid || node.tagName !== 'LI') continue;

            const productId = CollectionProductPriority.productIdFor(node);
            const pinnedCard = this.pinnedCards.get(productId);
            if (pinnedCard && node !== pinnedCard) {
              node.remove();
              removedDuplicate = true;
            }
          }
        }

        if (removedDuplicate) this.updateMobileCounters();
      });
      this.duplicateObserver.observe(this.grid, { childList: true });

      const gridParent = this.grid.parentElement;
      if (gridParent) {
        this.counterObserver = new MutationObserver(() => this.updateMobileCounters());
        this.counterObserver.observe(gridParent, { childList: true });
      }

      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer) {
        this.containerObserver = new MutationObserver(() => {
          if (!this.grid.isConnected) this.stopObservers();
        });
        this.containerObserver.observe(gridContainer, { childList: true });
      }
    }

    stopObservers() {
      this.duplicateObserver?.disconnect();
      this.counterObserver?.disconnect();
      this.containerObserver?.disconnect();
    }

    removeDuplicates() {
      for (const card of [...this.grid.querySelectorAll(':scope > li')]) {
        const productId = CollectionProductPriority.productIdFor(card);
        const pinnedCard = this.pinnedCards.get(productId);
        if (pinnedCard && card !== pinnedCard) card.remove();
      }
    }

    prioritizeFirstImage() {
      const firstCard = this.pinnedCards.values().next().value;
      const firstImage = firstCard?.querySelector('img');
      if (!firstImage) return;

      firstImage.loading = 'eager';
      firstImage.fetchPriority = 'high';
      firstImage.setAttribute('fetchpriority', 'high');
    }

    initializeCards() {
      for (const card of this.pinnedCards.values()) {
        if (card.dataset.productPriorityInjected === 'true') this.bindCollectionTracking(card);
        window.ResponsivePLPInfiniteScroll?.markProductAsLoaded?.(card);
      }

      if (typeof window.initProductImageSlider === 'function') window.initProductImageSlider();
      window.ResponsivePLPInfiniteScroll?.initProductJS?.();
    }

    synchronizeInfiniteScroll() {
      for (const card of this.pinnedCards.values()) card.style.removeProperty('display');

      const infiniteScroll = window.ResponsivePLPInfiniteScroll;
      if (typeof infiniteScroll?.insertLoaderAndSentinel !== 'function') return;

      window.requestAnimationFrame(() => {
        if (!this.grid?.isConnected) return;
        for (const card of this.pinnedCards.values()) card.style.removeProperty('display');
        infiniteScroll.insertLoaderAndSentinel();
      });
    }

    bindCollectionTracking(card) {
      const product = card.querySelector('.product-card-wrapper[data-product-id]');
      if (!product || product.dataset.priorityTrackingBound === 'true') return;
      product.dataset.priorityTrackingBound = 'true';

      product.addEventListener('click', (event) => {
        const link = event.target instanceof Element ? event.target.closest('[href]') : null;
        if (!link || !product.contains(link)) return;
        const productId = product.dataset.productId;
        const collectionData = {
          title: product.dataset.collectionTitle,
          url: product.dataset.collection,
        };

        let productsCollectionData = [];
        try {
          productsCollectionData = JSON.parse(localStorage.getItem('productsCollection')) || [];
        } catch {
          productsCollectionData = [];
        }

        const existingProduct = productsCollectionData.find((item) => String(item.id) === productId);
        if (existingProduct) {
          existingProduct.collection = collectionData;
        } else {
          productsCollectionData.push({ id: productId, collection: collectionData });
        }

        try {
          localStorage.setItem('productsCollection', JSON.stringify(productsCollectionData));
        } catch {
          // Tracking is best-effort; native link navigation must always remain available.
        }
      });
    }

    updateMobileCounters() {
      const totalElement = document.getElementById('total-number');
      const viewedElement = document.getElementById('current-last-viewed');

      if (Number.isInteger(this.totalProducts)) {
        if (totalElement) totalElement.textContent = String(this.totalProducts);
        if (window.ResponsivePLPInfiniteScroll && 'totalProductCount' in window.ResponsivePLPInfiniteScroll) {
          window.ResponsivePLPInfiniteScroll.totalProductCount = this.totalProducts;
        }
      }

      if (viewedElement) {
        const visibleProductIds = new Set(
          [...this.grid.querySelectorAll(':scope > li')]
            .map((card) => CollectionProductPriority.productIdFor(card))
            .filter(Boolean)
        );
        viewedElement.textContent = String(visibleProductIds.size);
      }
    }

    finish(status, appliedIds) {
      this.dataset.status = status;
      this.dataset.requestedIds = (this.requestedIds || []).join(',');
      this.dataset.appliedIds = appliedIds.join(',');
      this.dispatchEvent(
        new CustomEvent('collection-product-priority:complete', {
          bubbles: true,
          detail: {
            status,
            requestedIds: this.requestedIds || [],
            appliedIds,
          },
        })
      );
    }
  }

  if (!customElements.get('collection-product-priority')) {
    customElements.define('collection-product-priority', CollectionProductPriority);
  }

  } catch(e) { console.error(e); }
})();
})();
